import AppCard from './AppCard'
import RedirectСard from './RedirectСard'


export default AppCard
export { RedirectСard }
